export const TRUSTMARKS = {
  WILLS: 'Wills',
  FUNERALS: 'Funerals',
  PROBATE: 'Probate',
}
